export default __webpack_public_path__ + "static/media/font-size.9119c1a1.svg";